var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-menu', {
    attrs: {
      "offset-y": "",
      "disabled": _vm.disabled
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "speed-control-button",
          attrs: {
            "small": "",
            "disabled": _vm.disabled
          }
        }, 'v-btn', attrs, false), on), [_vm._v(" " + _vm._s(_vm.selectedSpeedLabel) + " "), _c('v-icon', {
          attrs: {
            "small": "",
            "right": ""
          }
        }, [_vm._v("mdi-menu-down")])], 1)];
      }
    }])
  }, [_c('v-list', {
    staticClass: "speed-control-menu",
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.speeds, function (s, index) {
    return _c('v-list-item', {
      key: index,
      on: {
        "click": function ($event) {
          return _vm.$emit('input', s.value);
        }
      }
    }, [_c('v-list-item-title', {
      staticClass: "speed-option",
      class: {
        selected: s.value === _vm.value
      }
    }, [_vm._v(" " + _vm._s(s.name) + " ")])], 1);
  }), 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }